import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  ArrowBackIos as ArrowBackIosIcon,
  Edit as EditIcon,
  Save as SaveIcon,
} from '@mui/icons-material';

/**
 * 훈련 상세 페이지 공통 헤더 컴포넌트
 * 
 * @param {Object} props
 * @param {Object} props.training - 훈련 데이터
 * @param {Function} props.onGoBack - 뒤로가기 핸들러
 * @param {boolean} props.isEditMode - 수정 모드 여부
 * @param {Function} props.onEnterEditMode - 수정 모드 진입 핸들러
 * @param {Function} props.onCancelEditMode - 수정 모드 취소 핸들러
 * @param {Function} props.onSubmitEdit - 수정 제출 핸들러
 * @param {boolean} props.isEditDirty - 수정 모드에서 변경사항 여부
 */
const TrainingDetailHeader = ({
  training,
  onGoBack,
  isEditMode,
  onEnterEditMode,
  onCancelEditMode,
  onSubmitEdit,
  isEditDirty,
}) => {
  return (
    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {/* 왼쪽 버튼 */}
      <Button
        variant='outlined'
        onClick={isEditMode ? onCancelEditMode : onGoBack}
        startIcon={<ArrowBackIcon />}
        sx={{ minWidth: 120 }}
      >
        {isEditMode ? '취소' : '목록으로'}
      </Button>

      {/* 중앙: 문제 정보 */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant='h6' fontWeight={600}>
          {training?.problemId}번 문제
        </Typography>
      </Box>

      {/* 오른쪽 버튼 */}
      {isEditMode ? (
        <Button
          variant='contained'
          onClick={onSubmitEdit}
          startIcon={<SaveIcon />}
          disabled={!isEditDirty}
          sx={{ minWidth: 100 }}
        >
          저장 및 종료
        </Button>
      ) : (
        <Button
          variant='contained'
          onClick={onEnterEditMode}
          startIcon={<EditIcon />}
          sx={{ minWidth: 100 }}
        >
          수정하기
        </Button>
      )}
    </Box>
  );
};

export default TrainingDetailHeader;
